// extracted by mini-css-extract-plugin
export default {"gallery":"ImageGallery_gallery__iK3au"};